import { Box } from "@mui/material";

export const AutostoreBinBorder = ({ rotate }: { rotate?: boolean }) => {
  return rotate ? (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        py: 2,
        px: 0.5
      }}
    >
      <Box
        sx={{
          backgroundColor: "common.white",
          py: 1.5,
          px: 0.8
        }}
      />
      <Box
        sx={{
          backgroundColor: "common.white",
          py: 1.5,
          px: 0.8
        }}
      />
    </Box>
  ) : (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        py: 0.5,
        px: 2
      }}
    >
      <Box
        sx={{
          backgroundColor: "common.white",
          px: 1.5,
          py: 0.8
        }}
      />
      <Box
        sx={{
          backgroundColor: "common.white",
          px: 1.5,
          py: 0.8
        }}
      />
    </Box>
  );
};
